// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3bMH6","active":"downloadDropdown_active__3ttEE"};